/**
 * Cookie-based login (/api/login) needs a Laravel session + CSRF/XSRF first.
 * MainProfile.vue did this for /profile only; главная и Header — нет → в Telegram чаще «случайно ок», в MAX WebView сессия не продолжается между запросами.
 */

export async function ensureSanctumSession (axiosInstance) {
  await axiosInstance.get('/sanctum/csrf-cookie')
}

/** Сообщить клиенту (Telegram / MAX), что мини-приложение готово — рекомендуется до тяжёлых действий и сети. */
export function notifyMiniAppReady () {
  try {
    const tg = typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp
    if (tg && typeof tg.ready === 'function') {
      tg.ready()
    }
  } catch (_) { /* noop */ }

  try {
    const maxApp = typeof window !== 'undefined' && window.WebApp
    if (maxApp && typeof maxApp.ready === 'function') {
      maxApp.ready()
    }
  } catch (_) { /* noop */ }
}
